import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import "./Sidebar.css";
import logo from "../assets/icons/CDR-Logo.png";
import logoutIcon from "../assets/icons/switch.png";
import { useAuthStore } from "../Services/authStore";
import { ChevronDown, ChevronUp } from "lucide-react";
function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState({
    core: true,
    operations: false,
    club: false,
    settings: false,
    masters: false,
  });

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };
  const logout = useAuthStore((state) => state.logout);
  const user = useAuthStore((state) => state.user);
  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };
  const userName =
    user?.name || user?.full_name || user?.username || user?.email || "User";

  const userRole = user?.role || user?.user_role || user?.designation || "User";

  const initials = userName
    .split(" ")
    .map((name) => name.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase();
  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      {/* Logo */}
      <div className="sidebar-logo">
        <img src={logo} alt="Logo" className="sidebar-logo-img" />

        <button
          className="collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? "›" : "‹"}
        </button>
      </div>

      {/* Scrollable Menu */}
      <div className="sidebar-menu">
        <div className="menu-section">
          {!collapsed && (
            <div
              className="section-title dropdown-title"
              onClick={() => toggleMenu("core")}
            >
              <span>CORE</span>
              {openMenus.core ? (
                <ChevronUp size={16} />
              ) : (
                <ChevronDown size={16} />
              )}
            </div>
          )}

          {openMenus.core && (
            <>
              <NavLink to="/dashboard" className="menu-item">
                <span>📊</span>
                {!collapsed && <span>Dashboard</span>}
              </NavLink>

              <NavLink to="/events" className="menu-item">
                <span>🍽️</span>
                {!collapsed && <span>Events</span>}
              </NavLink>

              <NavLink to="/MemberDirectory" className="menu-item">
                <span>📋</span>
                {!collapsed && <span>Member List</span>}
              </NavLink>

              <NavLink to="/EventParticipants" className="menu-item">
                <span>👥</span>
                {!collapsed && <span>Event Participants</span>}
              </NavLink>
            </>
          )}
        </div>

        <div className="menu-section">
          {!collapsed && (
            <div
              className="section-title dropdown-title"
              onClick={() => toggleMenu("operations")}
            >
              <span>OPERATIONS</span>
              {openMenus.operations ? (
                <ChevronUp size={16} />
              ) : (
                <ChevronDown size={16} />
              )}
            </div>
          )}

          {openMenus.operations && (
            <>
              {/* <NavLink to="/vendors" className="menu-item">
                <span>🏪</span>
                {!collapsed && <span>Vendors</span>}
              </NavLink> */}

              <NavLink to="/analytics" className="menu-item">
                <span>📈</span>
                {!collapsed && <span>Analytics</span>}
              </NavLink>

              <NavLink to="/communications" className="menu-item">
                <span>📢</span>
                {!collapsed && <span>Communications</span>}
              </NavLink>
            </>
          )}
        </div>

        <div className="menu-section">
          {!collapsed && (
            <div
              className="section-title dropdown-title"
              onClick={() => toggleMenu("club")}
            >
              <span>CLUB</span>
              {openMenus.club ? (
                <ChevronUp size={16} />
              ) : (
                <ChevronDown size={16} />
              )}
            </div>
          )}

          {openMenus.club && (
            <>
              <NavLink to="/finance" className="menu-item">
                <span>💰</span>
                {!collapsed && <span>Finance</span>}
              </NavLink>

              <NavLink to="/wine-tracker" className="menu-item">
                <span>🍷</span>
                {!collapsed && <span>Wine Tracker</span>}
              </NavLink>
            </>
          )}
        </div>

        <div className="menu-section">
          {!collapsed && (
            <div
              className="section-title dropdown-title"
              onClick={() => toggleMenu("settings")}
            >
              <span>SETTINGS</span>
              {openMenus.settings ? (
                <ChevronUp size={16} />
              ) : (
                <ChevronDown size={16} />
              )}
            </div>
          )}

          {openMenus.settings && (
            <>
              <div
                className="menu-item nested-dropdown"
                onClick={() => toggleMenu("masters")}
              >
                <div className="nested-title">
                  {!collapsed && <span>Masters</span>}
                </div>

                {!collapsed &&
                  (openMenus.masters ? (
                    <ChevronUp size={16} />
                  ) : (
                    <ChevronDown size={16} />
                  ))}
              </div>

              {openMenus.masters && (
                <div className="nested-menu">
                  <NavLink to="/userlist" className="menu-item nested-item">
                    <span>👤</span>
                    {!collapsed && <span>User List</span>}
                  </NavLink>
                  {/* 
                  <NavLink to="/finance" className="menu-item nested-item">
                    <span>📦</span>
                    {!collapsed && <span>Item Category</span>}
                  </NavLink> */}

                  {/* <NavLink to="/wine-tracker" className="menu-item nested-item">
                    <span>🧾</span>
                    {!collapsed && <span>Tax Code</span>}
                  </NavLink> */}

                  <NavLink
                    to="/DocumentMaster"
                    className="menu-item nested-item"
                  >
                    <span>🗂️</span>
                    {!collapsed && <span>Document Type</span>}
                  </NavLink>

                  <NavLink to="/GradeMaster" className="menu-item nested-item">
                    <span>🎓</span>
                    {!collapsed && <span>Grade Master</span>}
                  </NavLink>

                  <NavLink to="/RankMaster" className="menu-item nested-item">
                    <span>💲</span>
                    {!collapsed && <span>Rank Master</span>}
                  </NavLink>

                  <NavLink
                    to="/PriceCategoryMaster"
                    className="menu-item nested-item"
                  >
                    <span>🏷️</span>
                    {!collapsed && <span>Price Category Master</span>}
                  </NavLink>

                  <NavLink to="/RateMaster" className="menu-item nested-item">
                    <span>🏆</span>
                    {!collapsed && <span>Rate Master</span>}
                  </NavLink>

                  <NavLink
                    to="/ItemCategoryMaster"
                    className="menu-item nested-item"
                  >
                    <span>📦</span>
                    {!collapsed && <span>Item Category Master</span>}
                  </NavLink>

                  <NavLink
                    to="/TaxCodeMaster"
                    className="menu-item nested-item"
                  >
                    <span>🧾</span>
                    {!collapsed && <span>Tax Code</span>}
                  </NavLink>

                  <NavLink to="/VendorMaster" className="menu-item nested-item">
                    <span>🏪</span>
                    {!collapsed && <span>Vendor Master</span>}
                  </NavLink>

                  <NavLink to="/UnitMaster" className="menu-item nested-item">
                    <span>🏪</span>
                    {!collapsed && <span>Unit Master</span>}
                  </NavLink>
                  <NavLink to="/GuestMaster" className="menu-item nested-item">
                    <span>🏪</span>
                    {!collapsed && <span>Guest Master</span>}
                  </NavLink>
                  <NavLink to="/ApprovalMatrix" className="menu-item">
                    <span>📊</span>
                    {!collapsed && <span>Approval Matrix</span>}
                  </NavLink>

                  <NavLink to="/procurement" className="menu-item">
                    <span>📊</span>
                    {!collapsed && <span>Procurement</span>}
                  </NavLink>
                </div>
              )}

              {/* <NavLink to="/approvals" className="menu-item">
                <span>✅</span>
                {!collapsed && <span>Approvals</span>}
              </NavLink> */}
            </>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="sidebar-footer">
        {!collapsed ? (
          <div className="user-card">
            <div className="avatar">{initials}</div>

            <div>
              <div className="user-name">{userName}</div>
              <div className="user-role">{userRole}</div>
            </div>
          </div>
        ) : (
          <div className="avatar collapsed-avatar">{initials}</div>
        )}

        <button className="logout-btn" onClick={handleLogout}>
          <img src={logoutIcon} alt="Logout" className="logout-icon" />

          {!collapsed && <span>Logout</span>}
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
